

































































































import { Component, Prop, Vue } from "vue-property-decorator";
@Component({
  components: {}
})
export default class Esign extends Vue {
  public accepted: boolean = false;

  public hitBottom: boolean = false;

  onScroll({ target: { scrollTop, clientHeight, scrollHeight } }: any) {
    if (scrollTop + clientHeight >= scrollHeight - 1) {
      this.hitBottom = true;
    }
  }
}
